import TextInputPage from '@app-studio-web/ui/pages/TextInputPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'sleepGoal'

export default function SleepGoalPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value') || ''
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formData = new FormData(event.currentTarget)
    const goalName = formData.get('value') as string

    if (!goalName.trim()) return

    const answer = {
      question_key: QUESTION_KEY,
      question: t('pages.onboarding.sleepGoal.heading', { lng: 'en' }),
      answer_key: goalName.toLowerCase(),
      answer: goalName,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <TextInputPage
      heading="pages.onboarding.sleepGoal.heading"
      description="pages.onboarding.sleepGoal.description"
      placeholder="pages.onboarding.sleepGoal.placeholder"
      onSubmit={handleSubmit}
      value={value}
    />
  )
}
